import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SelectItem } from 'primeng/primeng';
import { ContrachequeListDTO } from '../../../shared/dominios/DTO/contracheque-list.DTO';
import { InformacaoContrachequeDTO } from '../../../shared/dominios/DTO/informacoes-contracheque.DTO';
import { MesAnoModel } from '../../../shared/models/mes-ano.model';
import { ContraChequeFuncCentrusModel } from '../../../shared/models/contra-cheque-func-centrus.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { FinanceiroService } from '../../service/financeiro.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { ToastrService } from 'ngx-toastr';
import { ContrachequeService } from '../service/contracheque.service';
import { DecimalPipe } from '@angular/common';
import { ContrachqueFuncionarioPdf } from '../../../shared/services/documentos-pdf-imprimir/financeiro/contracheques/contracheque-funcionario-pdf';
import { MessageUtil } from '../../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { ContrachequeDetalhesValoresModel } from '../../../shared/models/contracheque-detalhes-valores-func.model';

@Component({
  selector: 'app-contracheque-funcionario',
  templateUrl: './contracheque-funcionario.component.html',
  styleUrls: ['./contracheque-funcionario.component.css']
})
export class ContrachequeFuncionarioComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;

  cols: any[];

  cdCentrus: number;
  // cdCentrus = 10014;

  componentes: any[] = [1];

  mesesAno: SelectItem[] = [];

  contrachequeList: Array<ContrachequeListDTO> = new Array<ContrachequeListDTO>();
  bonusLista: Array<ContrachequeListDTO> = new Array<ContrachequeListDTO>();
  informacaoContrachequeDTO: InformacaoContrachequeDTO = new InformacaoContrachequeDTO()
  mesAno: string;

  mesAnoModel = new MesAnoModel();

  contraChequeFuncCentrusModel: ContraChequeFuncCentrusModel = new ContraChequeFuncCentrusModel();

  dadosCadastrais: Array<InformacaoContrachequeDTO> = new Array<InformacaoContrachequeDTO>();

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  page: number;
  param: string;
  outros = false;
  bonus = false;

  verbaDesconto = 0;
  verbaBonus546 = 0;
  verbaBonus = 0;
  imprime = 0;
  valorTotalLiquidoComBonus = 0;

  constructor(
    private financeiroService: FinanceiroService,
    private contrachequeService: ContrachequeService,
    private contrachqueFuncionarioPdf: ContrachqueFuncionarioPdf,
    private activatedRoute: ActivatedRoute,
    private authInterceptor: AuthInterceptor,
    private _decimalPipe: DecimalPipe,
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private router: Router
  ) { }


  ngOnInit() {

    this.cols = [
      { field: 1, header: 'Verba' },
      { field: 2, header: 'Descrição' },
      { field: 3, header: 'Parcela' },
      { field: 4, header: 'Saldo/Base de Cáculo' },
      { field: 5, header: 'Competência' },
      { field: 6, header: 'Valor' }
    ];
    this._gerenciarCodigoIndentificao();
  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuFinanceiro';
        }
        this.getPessoasDadosSimplificado();
      })
  }



  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoasDadosSimplificado(this.cdCentrus);
      this.getdDataReferencia();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }


  async getdDataReferencia() {
    this.mesesAno = [];
    try {
      const mesesRetorno = await this.financeiroService.getDataReferencia(this.cdCentrus);
      mesesRetorno.map(item => {
        this.mesesAno.push({ label: item, value: item })
      })
      this.mesAno = mesesRetorno[0];
      this.getEspelhoFolhaPagtoWeb(this.mesAno)
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  getContrachequeFuncCentrus(mesAno) {
    this.verbaDesconto = 0;
    this.verbaBonus546 = 0;
    this.verbaBonus = 0;
    this.valorTotalLiquidoComBonus = 0;
    this.getEspelhoFolhaPagtoWeb(mesAno);
  }


  getEspelhoFolhaPagtoWeb(mesAno: string) {

    if (mesAno === null) {
      return;
    }

    this.mesAnoModel = new MesAnoModel(Number(mesAno.split('/')[0]), Number(mesAno.split('/')[1]));


    this.getEspelhoFolhaPagtoWebFunc(this.mesAnoModel);
  }


  async getEspelhoFolhaPagtoWebFunc(mesAnoModel: MesAnoModel) {

    this.informacaoContrachequeDTO = new InformacaoContrachequeDTO();
    this.dadosCadastrais = new Array<InformacaoContrachequeDTO>();
    this.contrachequeList = new Array<ContrachequeListDTO>();
    this.bonusLista = new Array<ContrachequeListDTO>();
    this.bonus = false;
    this.outros = false;


    try {
      const contracheque = await this.contrachequeService.getEspelhoFolhaPagtoWebFunc(this.cdCentrus, mesAnoModel.mes, mesAnoModel.ano);

      this.configurarInformacaoContrachqueTela(contracheque);

      contracheque.contrachequeDetalhesValoresFuncDTO.map(i => {
        this.verificarOcoorenciaOutros(i);
        this.verificarOcorrenciaBonus(i);
      })

      this.dadosCadastrais.push(this.informacaoContrachequeDTO);

      if (contracheque.noPessoa) {
        this.contrachequeList.push(new ContrachequeListDTO(null, 'Proventos'.toUpperCase(), null, null, null, null));
      }

      contracheque.contrachequeDetalhesValoresFuncDTO.map(index => this.configurarProventosTela(index))

      if (this.outros) {
        this.contrachequeList.push(new ContrachequeListDTO(null, 'Outros'.toUpperCase(), null, null, null, null))
      }

      contracheque.contrachequeDetalhesValoresFuncDTO.map(index => this.configurarOutrosTela(index))

      if (contracheque.noPessoa) {
        this.contrachequeList.push(new ContrachequeListDTO(null, 'Descontos'.toUpperCase(), null, null, null, null))
      }

      this.imprime = 0;
      contracheque.contrachequeDetalhesValoresFuncDTO.map(index => {
        this.configurarDescontosTela(index);
        //this.configurarBonusTela(index);
        this.valorLiquidoBonus(index);
      })

      if (this.contrachequeList.length === 0) {
        this.voltarForcada()
      }

    } catch (error) {
      this.toastrService.info('Não foi encontrado contracheque para essa data', 'Não foi encontrado', { timeOut: 8000 })
    }
  }




  private configurarInformacaoContrachqueTela(contracheque: ContraChequeFuncCentrusModel) {
    this.informacaoContrachequeDTO = new InformacaoContrachequeDTO(
      contracheque.noPessoa,
      null,
      contracheque.sgLocal,
      null,
      contracheque.vlBruto,
      contracheque.vlDescontos,
      contracheque.vlLiquido,
      contracheque.nrBanco,
      contracheque.nrAgencia,
      contracheque.nrContaCorrente,
      contracheque.qtDepIr,
      contracheque.qtDepSalFam,
      contracheque.vlMargem30,
      contracheque.vlMargem70,
      (contracheque.cdFuncao + ' - ' + contracheque.sgCarreira),
      contracheque.vlSalarioBase,
      contracheque.vlFgts,
      contracheque.dsMensagemInd,
      'Valores Passíveis de alteração até  a data do crédito.'.toUpperCase()

    );
  }

  private configurarBonusTela(index: ContrachequeDetalhesValoresModel) {
    if (Number(index.cdVerba) === 545
      || Number(index.cdVerba) === 546
      || Number(index.cdVerba) === 547
      || Number(index.cdVerba) === 548
      || Number(index.cdVerba) === 1603
      || Number(index.cdVerba) === 1017
      || Number(index.cdVerba) === 1018
      || Number(index.cdVerba) === 1019) {

      this.bonusLista.push(
        new ContrachequeListDTO(
          (index.cdVerba + '.' + index.cdVariacao),
          index.dsVerbasCent.trim(),
          index.dsComplemento,
          this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
          this.mesAno,
          this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
        ));
    }
  }

  private valorLiquidoBonus(index: ContrachequeDetalhesValoresModel){

    if(Number(index.cdVerba) === 1603|| Number(index.cdVerba) === 1017 ){
        this.verbaDesconto = parseFloat(index.vlVerba);
    }

    if (Number(index.cdVerba) === 545
      //|| Number(index.cdVerba) === 546
      || Number(index.cdVerba) === 547
      || Number(index.cdVerba) === 548
      || Number(index.cdVerba) === 1018
      || Number(index.cdVerba) === 1019){
        this.verbaBonus = parseFloat(index.vlVerba);
    }

    if(Number(index.cdVerba) === 546){
        this.verbaBonus546 = parseFloat(index.vlVerba);
    }

    if((this.verbaBonus > 0 || this.verbaBonus546 > 0)
        && this.imprime === 0 && (this.verbaDesconto > 0)){
        this.imprime = 1;
        this.valorTotalLiquidoComBonus = ((this.verbaBonus + this.verbaBonus546) - this.verbaDesconto)
        this.contrachequeList.push(
            new ContrachequeListDTO(
              ('0000' + '.' + index.cdVariacao),
              'Líquido Partic. Resultados',
              '',
              this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
              this.mesAno,
              this._decimalPipe.transform(Number((this.verbaBonus + this.verbaBonus546) - this.verbaDesconto), '1.2-2')
            ));
    }
  }

  public calculaValorTotal(valorTotal: string){
    if(this.bonus){
        return parseFloat(valorTotal) - this.valorTotalLiquidoComBonus;
    }
    return valorTotal;
  }

  public calculaDescontoTotal(valorTotal: string){
    if(this.bonus){
    return parseFloat(valorTotal) + this.valorTotalLiquidoComBonus;
    }
    return valorTotal;
  }

  private configurarDescontosTela(index: ContrachequeDetalhesValoresModel) {

    if (Number(index.cdVerba) > 999 && Number(index.cdVerba) !== 1019  && Number(index.cdVerba) !== 1018
    && Number(index.cdVerba) !== 1014 ) {
      this.contrachequeList.push(
        new ContrachequeListDTO(
          (index.cdVerba + '.' + index.cdVariacao),
          index.dsVerbasCent.trim(),
          index.dsComplemento,
          this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
          this.mesAno,
          this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
        ));
    }
  }

  private configurarOutrosTela(index: ContrachequeDetalhesValoresModel) {
    if (Number(index.cdVerba) === 681
      || Number(index.cdVerba) === 691
      || Number(index.cdVerba) === 741) {

      this.contrachequeList.push(
        new ContrachequeListDTO(
          (index.cdVerba + '.' + index.cdVariacao),
          index.dsVerbasCent.trim(),
          index.dsComplemento,
          this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
          this.mesAno,
          this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
        ));
    }
  }

  private configurarProventosTela(index: ContrachequeDetalhesValoresModel) {
    if (Number(index.cdVerba) < 1000
      && Number(index.cdVerba) !== 681
      && Number(index.cdVerba) !== 691
      || Number(index.cdVerba) === 1019
      || Number(index.cdVerba) === 1018
      || Number(index.cdVerba) === 1014
      && Number(index.cdVerba) !== 741) {
      //&& Number(index.cdVerba) !== 545
      //&& Number(index.cdVerba) !== 546
      //&& Number(index.cdVerba) !== 547
     //&& Number(index.cdVerba) !== 548

      this.contrachequeList.push(
        new ContrachequeListDTO(
          (index.cdVerba + '.' + index.cdVariacao),
          index.dsVerbasCent.trim(),
          index.dsComplemento,
          this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
          this.mesAno,
          this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
        ));
    }
  }

  private verificarOcorrenciaBonus(i: ContrachequeDetalhesValoresModel) {
    if ((Number(i.cdVerba) === 545) ||
      (Number(i.cdVerba) === 546) ||
      (Number(i.cdVerba) === 547) ||
      (Number(i.cdVerba) === 548) ||
      (Number(i.cdVerba) === 1019) ||
      (Number(i.cdVerba) === 1018) ||
      (Number(i.cdVerba) === 1017) ||
      (Number(i.cdVerba) === 1603)) {
      this.bonus = true
    };
  }

  private verificarOcoorenciaOutros(i: ContrachequeDetalhesValoresModel) {
    if ((Number(i.cdVerba) === 681) ||
      (Number(i.cdVerba) === 691) ||
      (Number(i.cdVerba) === 741)) {
      this.outros = true
    };
  }

  imprimirPagina() {
    this.contrachqueFuncionarioPdf.funcionarios(this.mesAno, this.pessoaDadosSimplicadosModel, this.informacaoContrachequeDTO,
      this.contrachequeList, this.bonus, this.bonusLista, this.valorTotalLiquidoComBonus);
  }

  voltarForcada(): void {
    this.router.navigate([this.param], { skipLocationChange: true });
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/contracheque/contracheque-funcionario/contracheque-funcionario.component.ts